module.exports = __webpack_public_path__ + "static/flags/TL-f1e391bf17ae49c282077d24c1b5ecf1.gif";